module.exports = __webpack_public_path__ + "static/media/view talent sub category.03aae371.svg";